import { Route, Redirect, Switch, useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import MainPage from '../MainPage';
import { selectors as loginSelectors } from '../LoginPage/reducer';
import LoginPage from '../LoginPage';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import NotificationsList from '../../components/NotificationsList';
import faviconSvg from '../../global/media/favicon.svg';
import EditorPage from '../EditorPage/EditorPage';
import ClientLoyaltyPage from '../ClientLoyaltyPage';

// Статические документы лежат в /public с расширением .htm — сервер отдаёт их
// напрямую. Путь без расширения (сюда 301-ит старые ссылки на .html) в SPA
// не должен уходить на /login — уводим сразу на сам документ.
const STATIC_DOC_PATHS = [
  '/user-agreement',
  '/confidentiality',
  '/instruction',
];

const InitComponent = () => {
  const accessToken = useSelector(loginSelectors.accessToken);
  const refreshToken = useSelector(loginSelectors.refreshToken);

  const history = useHistory();

  const staticDocPath = STATIC_DOC_PATHS.find(
    (path) => history.location.pathname === path
  );

  useEffect(() => {
    if (staticDocPath) {
      window.location.replace(`${staticDocPath}.htm`);
    }
  }, [staticDocPath]);

  const isShowLayout = useMemo(
    () => !history.location.pathname.includes('/user-offline-address-screen'),
    [history]
  );

  const selectStartPage = () => {
    if (staticDocPath) {
      return null;
    }
    if (accessToken && refreshToken) {
      return <MainPage />;
    }
    return (
      <>
        <Helmet>
          <link rel="icon" type="image/png" href={faviconSvg} />
        </Helmet>
        <div>
          {isShowLayout && <Header />}
          <Switch>
            <Route exact path="/login" component={LoginPage} />
            <Route exact path="/editor" component={EditorPage} />
            <Route
              exact
              path="/user-offline-address-screen"
              component={ClientLoyaltyPage}
            />
            {!accessToken && <Redirect to="/login" />}
          </Switch>
          {isShowLayout && <Footer />}
          <NotificationsList />
        </div>
      </>
    );
  };
  return selectStartPage();
};

export default InitComponent;
